import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HesbeService } from './hesbe.service';


@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    HesbeService
  ]
})
export class HesbeModule { }
